//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { ModalFormMixin } from '@/mixins/ModalFormMixin';
import IwsUpload from '@comp/upload/IwsUpload';
import { httpAction } from '@api/manage';
import MapGetPoint from '@/components/Map/MapGetPoint';
import { queryAreaTreeList } from '@/api/api';
import pick from "lodash.pick";
import moment from "moment/moment";
export default {
  name: 'CompanyModal',
  mixins: [ModalFormMixin],
  components: {
    IwsUpload: IwsUpload,
    MapGetPoint: MapGetPoint
  },
  data: function data() {
    return {
      title: '一企一档表单',
      tableName: 'site_company',
      form_fields: ['companyName', 'companyCode', 'businessScope', 'creditCode', 'type', 'industry', 'areaId', 'address', 'legalPerson', 'website', 'contact', 'contactTel', 'businessTerm', 'longitude', 'latitude', 'remark', 'sort', 'tenantId'],
      form_fields_time: ['sDate'],
      validatorRules: {
        companyName: {
          rules: [{
            required: true,
            message: '请输入企业全称!'
          }]
        },
        companyCode: {
          rules: [{
            required: true,
            message: '请输入组织机构代码!'
          }]
        },
        legalPerson: {
          rules: [{
            required: true,
            message: '请输入法定代表人!'
          }]
        },
        type: {
          rules: [{
            required: true,
            message: '请选择企业类别!'
          }]
        },
        // areaId: {rules: [{required: true, message: '请选择所属区域!'}]},
        contact: {
          rules: [{
            required: true,
            message: '请输入联系人!'
          }]
        },
        longitude: {
          rules: [{
            required: true,
            message: '请输入经度!'
          }]
        },
        latitude: {
          rules: [{
            required: true,
            message: '请输入纬度!'
          }]
        },
        contactTel: {
          rules: [{
            required: true,
            message: '请输入联系人电话!'
          }]
        }
      },
      currentUrl: '',
      areaTree: []
    };
  },
  props: ['pagePath'],
  created: function created() {
    this.currentUrl = window.location.href;
  },
  watch: {
    $route: function $route(to, form) {
      this.currentUrl = window.location.href;
    }
  },
  methods: {
    add: function add() {
      this.edit({});
    },
    edit: function edit(record) {
      var _this = this;

      this.form.resetFields();
      this.model = Object.assign({}, record);
      this.visible = true;
      this.loadAreaTree();
      this.$nextTick(function () {
        var that = _this; //debugger

        that.form.setFieldsValue(pick(that.model, that.form_fields));
        that.form.setFieldsValue({
          sDate: _this.model.sDate ? moment(_this.model.sDate) : null
        });
        _this.mapCenter = [];

        if (typeof _this.model.longitude != 'undefined' && typeof _this.model.latitude != 'undefined') {
          _this.mapCenter.push(_this.model.longitude);

          _this.mapCenter.push(_this.model.latitude);
        }

        _this.$refs.iwupload.loadUploadFiles();
      });
    },
    handleOk: function handleOk() {
      var _this2 = this;

      var that = this; // 触发表单验证

      this.form.validateFields(function (err, values) {
        if (!err) {
          that.confirmLoading = true;
          var formData = Object.assign(that.model, values);
          formData = _this2.$refs.iwupload.getUploadListToFromData(formData);
          var httpurl = '',
              method = '';

          if (!_this2.model.id) {
            httpurl = _this2.url.add ? _this2.url.add : _this2.pagePath;
            method = 'post';
          } else {
            httpurl = _this2.url.edit ? _this2.url.edit : _this2.pagePath;
            method = 'put';
          }

          if (_this2.currentUrl.indexOf('/CompanyList/breed') != -1) {
            formData.type = '1';
          }

          httpAction(httpurl, formData, method).then(function (res) {
            if (res.success) {
              _this2.$refs.iwupload.resetUploadFiles();

              that.$notification.success({
                message: res.message
              });
              that.$emit('ok');
              that.close();
            } else {
              that.$notification.warning({
                message: res.message
              });
            }
          }).finally(function () {
            that.confirmLoading = false;
          });
        }
      });
    },
    handleCancel: function handleCancel() {
      this.close();
    },
    longitudeChange: function longitudeChange() {
      this.$refs.mapForm.show(this.mapCenter);
    },
    coordinateOk: function coordinateOk(value) {
      if (value != null) {
        this.form.setFieldsValue({
          longitude: value[0] ? value[0] : null
        });
        this.form.setFieldsValue({
          latitude: value[1] ? value[1] : null
        });
      }
    },
    loadAreaTree: function loadAreaTree() {
      var _this3 = this;

      var that = this;
      that.areaTree = []; // 流域
      // 区域

      queryAreaTreeList({
        status: '1'
      }).then(function (res) {
        if (res.success) {
          for (var i = 0; i < res.result.length; i++) {
            var temp = res.result[i];
            temp.key = temp.key;
            that.areaTree.push(temp);
          }

          _this3.loading = false;
        }
      });
    }
  }
};